/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MoneyInTrustlyInitOutput
 */
export interface MoneyInTrustlyInitOutput {
    /**
     * Transaction ID. You will this this value to confirm the transaction
     * @type {number}
     * @memberof MoneyInTrustlyInitOutput
     */
    id?: number;
    /**
     * Redirected URL for the client on the iDeal page payment
     * @type {string}
     * @memberof MoneyInTrustlyInitOutput
     */
    actionUrl?: string;
    /**
     * 
     * @type {Error}
     * @memberof MoneyInTrustlyInitOutput
     */
    error?: Error;
}

/**
 * Check if a given object implements the MoneyInTrustlyInitOutput interface.
 */
export function instanceOfMoneyInTrustlyInitOutput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MoneyInTrustlyInitOutputFromJSON(json: any): MoneyInTrustlyInitOutput {
    return MoneyInTrustlyInitOutputFromJSONTyped(json, false);
}

export function MoneyInTrustlyInitOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): MoneyInTrustlyInitOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'actionUrl': !exists(json, 'actionUrl') ? undefined : json['actionUrl'],
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function MoneyInTrustlyInitOutputToJSON(value?: MoneyInTrustlyInitOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'actionUrl': value.actionUrl,
        'error': value.error,
    };
}

